import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@phosphor-icons/react';
import { CalendarBlankIcon, WarningOctagonIcon } from '@phosphor-icons/react';
import { parseLocalDate } from '@utils/helpers/src/date';
import { formatDate } from '@utils/utils-format';
import { useRef, useState } from 'react';
import { cx } from '../../cx';
import { BaseButton } from '../button/button';
import type { DateRangePickerProps } from '../datepicker/date-range-picker/date-range-picker';
import { DateRangePicker } from '../datepicker/date-range-picker/date-range-picker';
import { SimpleModal } from '../modal';
interface InputDateProps {
  value?: Date | string;
  name?: string;
  label?: string;
  error?: string | false;
  required?: boolean;
  minDate: Date;
  maxDate: Date;
  icon?: Icon;
  onChange?: (date: Date) => void;
}
export const InputDate = t0 => {
  const $ = _c(61);
  let error;
  let icon;
  let label;
  let maxDate;
  let minDate;
  let onChange;
  let rest;
  let t1;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      label,
      minDate,
      maxDate,
      icon,
      error,
      required: t1,
      onChange,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = error;
    $[2] = icon;
    $[3] = label;
    $[4] = maxDate;
    $[5] = minDate;
    $[6] = onChange;
    $[7] = rest;
    $[8] = t1;
    $[9] = value;
  } else {
    error = $[1];
    icon = $[2];
    label = $[3];
    maxDate = $[4];
    minDate = $[5];
    onChange = $[6];
    rest = $[7];
    t1 = $[8];
    value = $[9];
  }
  const required = t1 === undefined ? false : t1;
  const inputRef = useRef(null);
  const Icon = icon || CalendarBlankIcon;
  const [dismissed, setDismissed] = useState(false);
  const [dateModalVisible, setDateModalVisible] = useState(false);
  let t2;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setDateModalVisible(true);
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const showDateModal = t2;
  let t3;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setDismissed(true);
      setDateModalVisible(false);
    };
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const hideDateModal = t3;
  let t4;
  if ($[12] !== onChange) {
    t4 = date => {
      if (!date || !onChange) {
        return;
      }
      onChange(date);
      hideDateModal();
    };
    $[12] = onChange;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const dateChanged = t4;
  let dateValue;
  if (value) {
    let t5;
    if ($[14] !== value) {
      t5 = typeof value === "string" ? parseLocalDate({
        local: value
      }) : value;
      $[14] = value;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    dateValue = t5;
  }
  let t5;
  if ($[16] !== dateValue) {
    t5 = dateValue ? formatDate(dateValue) : undefined;
    $[16] = dateValue;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const displayValue = t5;
  let t6;
  if ($[18] !== dateChanged || $[19] !== dateModalVisible || $[20] !== dateValue || $[21] !== label || $[22] !== maxDate || $[23] !== minDate) {
    t6 = <DatepickerSimpleModal isOpen={dateModalVisible} title={label} value={dateValue} onChange={dateChanged} onClose={hideDateModal} min={minDate} max={maxDate} />;
    $[18] = dateChanged;
    $[19] = dateModalVisible;
    $[20] = dateValue;
    $[21] = label;
    $[22] = maxDate;
    $[23] = minDate;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  const t7 = !value && !dismissed ? showDateModal : undefined;
  const t8 = !value;
  let t9;
  if ($[25] !== error || $[26] !== t8 || $[27] !== value) {
    t9 = cx("relative flex items-center space-x-2 rounded-lg border border-primary/30 px-4 font-base-label", {
      "py-0 pb-1": value,
      "py-3": t8,
      "border-error": error
    });
    $[25] = error;
    $[26] = t8;
    $[27] = value;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== Icon) {
    t10 = <Icon size={24} />;
    $[29] = Icon;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== value) {
    t11 = cx("text-left text-secondary-text", {
      "pt-1 font-base-caption": value
    });
    $[31] = value;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  const t12 = required ? `${label}*` : label;
  let t13;
  if ($[33] !== t11 || $[34] !== t12) {
    t13 = <span className={t11}>{t12}</span>;
    $[33] = t11;
    $[34] = t12;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  const t14 = !value;
  let t15;
  if ($[36] !== t14) {
    t15 = cx("m-0 border-none p-0 text-left font-base-label focus:ring-0", {
      "h-px": t14
    });
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  const t16 = displayValue ?? "";
  let t17;
  if ($[38] !== rest || $[39] !== t15 || $[40] !== t16) {
    t17 = <input readOnly={true} type="text" className={t15} value={t16} ref={inputRef} {...rest} />;
    $[38] = rest;
    $[39] = t15;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t13 || $[43] !== t17) {
    t18 = <div className="flex shrink flex-col justify-start align-start">{t13}{t17}</div>;
    $[42] = t13;
    $[43] = t17;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== error) {
    t19 = error && <WarningOctagonIcon height={24} width={24} className="absolute right-3 text-error" />;
    $[45] = error;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t10 || $[48] !== t18 || $[49] !== t19 || $[50] !== t9) {
    t20 = <div className={t9}>{t10}{t18}{t19}</div>;
    $[47] = t10;
    $[48] = t18;
    $[49] = t19;
    $[50] = t9;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== t20 || $[53] !== t7) {
    t21 = <BaseButton className="w-full outline-primary" onClick={showDateModal} onFocus={t7}>{t20}</BaseButton>;
    $[52] = t20;
    $[53] = t7;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] !== error) {
    t22 = error && <p className="pt-2 pl-3 font-base-caption text-error">{error}</p>;
    $[55] = error;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  let t23;
  if ($[57] !== t21 || $[58] !== t22 || $[59] !== t6) {
    t23 = <>{t6}{t21}{t22}</>;
    $[57] = t21;
    $[58] = t22;
    $[59] = t6;
    $[60] = t23;
  } else {
    t23 = $[60];
  }
  return t23;
};
type DatepickerSimpleModalProps = {
  isOpen: boolean;
  title?: string;
  value?: Date;
  onClose: VoidFunction;
  onChange?: (value: Date | null) => void;
} & Pick<DateRangePickerProps, 'min' | 'max'>;
function DatepickerSimpleModal(t0) {
  const $ = _c(24);
  let isOpen;
  let max;
  let min;
  let onChange;
  let onClose;
  let rest;
  let title;
  let value;
  if ($[0] !== t0) {
    ({
      isOpen,
      onClose,
      title,
      value,
      min,
      max,
      onChange,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = isOpen;
    $[2] = max;
    $[3] = min;
    $[4] = onChange;
    $[5] = onClose;
    $[6] = rest;
    $[7] = title;
    $[8] = value;
  } else {
    isOpen = $[1];
    max = $[2];
    min = $[3];
    onChange = $[4];
    onClose = $[5];
    rest = $[6];
    title = $[7];
    value = $[8];
  }
  const t1 = title || "Datum w\xE4hlen";
  let t2;
  if ($[9] !== value) {
    t2 = value ? [value, null] : null;
    $[9] = value;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== onChange) {
    t3 = range => {
      const selectedDate = range?.[0] ?? null;
      onChange?.(selectedDate);
    };
    $[11] = onChange;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== max || $[14] !== min || $[15] !== rest || $[16] !== t2 || $[17] !== t3) {
    t4 = <DateRangePicker min={min} max={max} value={t2} onChange={t3} {...rest} />;
    $[13] = max;
    $[14] = min;
    $[15] = rest;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== isOpen || $[20] !== onClose || $[21] !== t1 || $[22] !== t4) {
    t5 = <SimpleModal isOpen={isOpen} onClose={onClose} title={t1}>{t4}</SimpleModal>;
    $[19] = isOpen;
    $[20] = onClose;
    $[21] = t1;
    $[22] = t4;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  return t5;
}